
import runewords from '../data/runewords';

function getRunewordsByRunes(ownedRunes) {
  let results = [];
  runewords.forEach(runeword => {
    let hasAll = true;
    runeword.runes.forEach(rune => {
      if(!ownedRunes.includes(rune)) hasAll = false;
    })
    if(hasAll) results.push(runeword)
  })
  return results;
}

export default getRunewordsByRunes;